import { cairo, CallData } from 'starknet';
export function buildRedeemSolverTx(params) {
    return {
        contractAddress: params.contractAddress,
        entrypoint: 'redeem_solver',
        calldata: CallData.compile([
            cairo.uint256(BigInt(params.id)),
            cairo.uint256(BigInt(params.index ?? 1)),
            cairo.uint256(BigInt(params.secret)),
        ]),
    };
}
